import axios from 'axios';
class PayloadBuilder {
  

    
}

export const payloadBuilder=new PayloadBuilder();